import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { ApiClient } from './api.client.js';

export interface VisionSnippet {
  id: string;
  cameraId: string;
  durationMs: number;
  source: string;
  createdAt: string;
  url: string | null;
}

export const VISION_SNIPPET_DURATIONS = [5, 6, 7, 8, 9, 10];

export const VisionSnippetsApiKeys = {
  SNIPPETS: 'VISION_SNIPPETS',
};

export class VisionSnippetsApi extends ApiClient {
  static list(cameraId: string): Promise<VisionSnippet[]> {
    return this.http.get(`/cameras/${cameraId}/vision-snippets`).then((res) => res.data);
  }

  static record(cameraId: string, durationSeconds: number): Promise<VisionSnippet> {
    return this.http.post(`/cameras/${cameraId}/vision-snippets`, { durationSeconds }).then((res) => res.data);
  }
}

export function useVisionSnippets(cameraId: string, enabled: boolean) {
  return useQuery([VisionSnippetsApiKeys.SNIPPETS, cameraId], () => VisionSnippetsApi.list(cameraId), { enabled });
}

export function useRecordVisionSnippet(cameraId: string) {
  const queryClient = useQueryClient();
  return useMutation((durationSeconds: number) => VisionSnippetsApi.record(cameraId, durationSeconds), {
    onSuccess: () => queryClient.invalidateQueries([VisionSnippetsApiKeys.SNIPPETS, cameraId]),
  });
}
